// 页面导航沿用原 navigation 渲染器及项目内跳转，不接受网址、脚本或任意参数。
export const defaultPageNavigation = () => ({ type: 'pages', source: 'all', items: [], inheritContext: true })
export const pageNavigationStyle = Object.freeze({ appearance: 'tech', gap: 0, fontSize: 18, radius: 0, glowStrength: 55,
  color: '#a8c3df', backgroundColor: 'transparent', activeColor: '#edfbff', activeBackground: '#08335a', borderColor: '#17cfff' })

export function pageNavigationIssue (action, pages = []) {
  if (!action || action.type !== 'pages' || !['all', 'custom'].includes(action.source)) return '请选择有效的页面导航范围'
  if (Object.keys(action).some(key => !['type', 'source', 'items', 'inheritContext'].includes(key))) return '页面导航包含不支持的字段'
  if (action.inheritContext !== undefined && typeof action.inheritContext !== 'boolean') return '导航参数继承开关无效'
  if (!Array.isArray(action.items) || action.items.length > 100) return '导航项须为列表，最多100项'
  if (action.source === 'all') return action.items.length ? '全部页面模式不保存自定义导航项' : ''
  if (!action.items.length) return '请至少添加一个导航页面'
  const used = new Set()
  for (let index = 0; index < action.items.length; index++) {
    const item = action.items[index], prefix = '导航项' + (index + 1) + '：'
    if (!item || typeof item !== 'object' || Array.isArray(item) || typeof item.pageId !== 'string' || !pages.some(page => page.id === item.pageId)) return prefix + '请选择有效页面；原页面可能已删除'
    if (Object.keys(item).some(key => !['pageId', 'label'].includes(key))) return prefix + '不支持外部链接、脚本或参数'
    if (used.has(item.pageId)) return prefix + '页面重复'
    if (item.label !== undefined && (typeof item.label !== 'string' || item.label.length > 60)) return prefix + '名称最多60个字符'
    used.add(item.pageId)
  }
  return ''
}

export function pageNavigationItems (action, pages = []) {
  if (!action) action = defaultPageNavigation()
  if (action.type !== 'pages') return []
  const items = action.source === 'all' ? pages.map(page => ({ pageId: page.id })) : Array.isArray(action.items) ? action.items.slice(0, 100) : []
  return items.map((item, index) => {
    const page = item && pages.find(page => page.id === item.pageId)
    const label = item && typeof item.label === 'string' && item.label.trim() ? item.label.trim().slice(0, 60) : page ? page.name : '请选择页面'
    return { pageId: page && page.id, label, key: index, unavailable: !page }
  })
}

export function pageNavigationAction (action, pages, pageId) {
  const config = action || defaultPageNavigation()
  const issue = pageNavigationIssue(config, pages)
  if (issue) throw new Error(issue)
  if (!pageNavigationItems(config, pages).some(item => item.pageId === pageId && !item.unavailable)) throw new Error('此页面不在当前导航中')
  return { type: 'page', pageId, params: config.inheritContext === false ? { productId: { source: 'clear' }, deviceId: { source: 'clear' } } : {} }
}

export function createPageNavigation () {
  return { label: '页面导航', cover: 'ui/component-page-navigation.svg', option: {
    name: '页面导航', title: '页面导航', icon: 'el-icon-menu', dataType: 0, data: {}, navigation: defaultPageNavigation(),
    component: { width: 420, height: 52, name: 'navigation', prop: 'navigation' },
    option: { mode: 'pages', direction: 'horizontal', equalWidth: true, ...pageNavigationStyle }
  } }
}
